"use client";

import type { UseOpenApiQueryOptions } from "../../../../request/hooks/openApi/useOpenApiQuery";
import { useOpenApiQuery } from "../../../../request/hooks/openApi/useOpenApiQuery";

const DRAFT_EVENT_PATH =
  "/communities/{community_id}/admin/events/drafts/{encoded_segment_id}" as const;

export type UseRequestCommunityDraftEventProps = Omit<
  UseOpenApiQueryOptions<typeof DRAFT_EVENT_PATH>,
  "urlBackendPath" | "params"
> & {
  communityId: number;
  segmentId: string;
};

export const useRequestCommunityDraftEvent = ({
  communityId,
  segmentId,
  ...props
}: UseRequestCommunityDraftEventProps) => ({
  query: useOpenApiQuery({
    ...props,
    urlBackendPath: DRAFT_EVENT_PATH,
    params: {
      path: { community_id: communityId, encoded_segment_id: segmentId },
    },
    queryKey: ["community-draft-event", communityId, segmentId],
  }),
});
